import { useField, useFormikContext } from 'formik';
import {
  TextAutocomplete,
  TextAutocompleteProps,
} from 'shared/form/TextAutocomplete';
import { useVehicleMakes } from '../data/VehiclesAPI';

interface FormikVehicleMakeFieldProps extends Omit<
  TextAutocompleteProps,
  'useOptions' | 'onBlur' | 'onChange'
> {
  name: string;
}

export function FormikVehicleMakeField({
  name,
  disabled,
  helperText,
  ...props
}: FormikVehicleMakeFieldProps) {
  const { isSubmitting } = useFormikContext();
  const [field, { error, touched }, { setValue }] = useField<string>(name);
  const errorText = touched && error;
  const useOptions = (keyword: string | undefined) => {
    const { data } = useVehicleMakes(keyword, { staleTime: Infinity });
    return data;
  };

  return (
    <TextAutocomplete
      {...props}
      {...field}
      error={!!errorText}
      useOptions={useOptions}
      disabled={disabled || isSubmitting}
      helperText={errorText || helperText}
      onChange={(nextValue) => {
        void setValue(nextValue);
      }}
    />
  );
}
